export default "__VITE_ASSET__BZQi06o1__"